const genreActionTypes = {
  FETCH_MOVIE_BY_GENRE_START: "FETCH_MOVIE_BY_GENRE_START",
  FETCH_MOVIE_BY_GENRE_SUCCESS: "FETCH_MOVIE_BY_GENRE_SUCCESS",
  FETCH_MOVIE_BY_GENRE_FAILURE: "FETCH_MOVIE_BY_GENRE_FAILURE",

  FETCH_GENRES_START: "FETCH_GENRES_START",
  FETCH_GENRES_SUCCESS: "FETCH_GENRES_SUCCESS",
  FETCH_GENRES_FAILURE: "FETCH_GENRES_FAILURE",

  LOAD_MORE_MOVIES_GENRE_START: "LOAD_MORE_MOVIES_GENRE_START",
  LOAD_MORE_MOVIES_SUCCESS: "LOAD_MORE_MOVIES_SUCCESS",
  LOAD_MORE_MOVIES_FAILURE: "LOAD_MORE_MOVIES_FAILURE",

  HAS_MORE_MOVIES: "HAS_MORE_MOVIES",
};

export default genreActionTypes;
